import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import ProfileCard from '@/components/Profile/ProfileCard';
import MyInvestment from '@/components/Profile/MyInvestment';
import { PageHeader } from '@/components/PageHeader';
import { BreadcrumbItem } from '@/components/Breadcrumb';
import { getDetailsMember } from './function';
import { getUserInfo } from '@/pages/Auth/function';
import { message } from 'antd';
import { InvestmentPackage } from '@/api/type';


const MemberDetails: React.FC = () => {
  const { t } = useTranslation();
  const { memberId } = useParams<{ memberId: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [investments, setInvestments] = useState<InvestmentPackage[]>([]);

  const [user, setUser] = useState<{
    id: number;
    fullname: string;
    email: string;
    avatar: string | null;
    phone: string | null;
    gender: string | null;
    birthday: string | null;
    job_title: string | null;
  } | null>(null);

  useEffect(() => {
    // Simulate API call to fetch investments
    const fetchInvestments = async () => {
      setLoading(true);
      try {
        getDetailsMember(memberId!).then((res) => {
          if (res) {
            const { data: packages } =  res;
            setInvestments(packages);
            if (packages.length > 0 && packages[0].user_info) {
              const userInfo = packages[0].user_info;
              setUser({
                id: userInfo.id,
                fullname: userInfo.fullname,
                email: userInfo.email,
                avatar: userInfo.avatar,
                phone: userInfo.phone,
                job_title: userInfo.job_title,
                birthday: userInfo.birthday,
                gender: userInfo.gender ? userInfo.gender == 1 ? 'male' : userInfo.gender == 2 ? 'female' : 'other' : 'other',
              });
            }
          } else {
            setInvestments([]);
          }
        });
      } catch (error) {
        console.error('Error fetching investments:', error);
      }
    };
    fetchInvestments();
    setLoading(false);
  }, [memberId]);


  const breadcrumbs: BreadcrumbItem[] = [
    { label: t('nav.dashboard', 'Dashboard'), path: '/home' },
    { label: t('loyalty.memberManagement', 'Quản lý thành viên'), path: '/members' },
    { label: user ? user.fullname : t('loyalty.memberDetails', 'Chi tiết thành viên'), path: `/members/${memberId}` },
  ];

  return (
    <div className="space-y-6">
      <PageHeader title={user ? user.fullname : t('loyalty.memberDetails', 'Chi tiết thành viên')} breadcrumbs={breadcrumbs} />
      <>
        {user ? (
          <div className="flex flex-col lg:flex-row gap-6">
            <div className="w-full lg:w-100 flex-shrink-0">
              <ProfileCard user={{
                fullname: user.fullname,
                email: user.email,
                avatar_url: user.avatar || '',
                phone: user.phone || '',
                birthday: user.birthday || '',
                gender: (user.gender as 'male' | 'female' | 'other') || 'other',
                job_title: user.job_title || '',
              }} />
            </div>

            <div className="flex-1 min-w-0">
              <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm overflow-hidden">
                <div className="border-b border-gray-100 dark:border-gray-700 px-6 py-4">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                    {t('profile.myInvestment', 'Đầu tư của') + ' ' + (user ? user.fullname : '')}
                  </h3>
                </div>
                <div className="p-6">
                  <MyInvestment investments={investments} loading={loading} allowRedirect={false} showScheduleButton={false} />
                </div>
              </div>
            </div>
          </div>
        ): (
          <p>{t('loyalty.loadingMemberInfo', 'Đang tải thông tin thành viên...')}</p>
        )}
      </>
    </div>
  )
};

export default MemberDetails;
